export default [
  {
    path: '/my',
    component: () => import('@views/my'),
    children: (pre => [
      {
        path: pre,
        component: () => import('@views/my/myIndex'),
        name: 'myIndex',
        meta: {
          isLogin: true,
          isFooterShow: true,
          title : '我的'
        }
      },
      {
        path: pre + '/couponList',
        component: () => import('@views/my/couponList'),
        name: 'couponList',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '优惠券'
        }
      },
      {
        path: pre + '/vipRecharge',
        component: () => import('@views/my/vipRecharge'),
        name: 'vipRecharge',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '充值'
        }
      },
      {
        path: pre + '/rechargeRecord',
        component: () => import('@views/my/vipRecharge/rechargeRecord'),
        name: 'rechargeRecord',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '充值列表'
        }
      },
      {
        path: pre + '/purchasedServices',
        component: () => import('@views/my/purchasedServices'),
        name: 'purchasedServices',
        meta: {
          isLogin: true,
          isFooterShow: false,
          keepAlive: false,
          title : '已购服务'
        }
      },
      {
        path: pre + '/purchaseDetail',
        component: () => import('@views/my/purchaseDetail'),
        name: 'purchaseDetail',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '我的服务详情'
        }
      },
      {
        path: pre + '/address/list',
        component: () => import('@views/my/address/list'),
        name: 'addressList',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '地址信息'
        }
      },
      {
        path: pre + '/address/edit',
        component: () => import('@views/my/address/edit'),
        name: 'addressEdit',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '编辑地址'
        }
      },
      {
        path: pre + '/feedback',
        component: () => import('@views/my/feedback'),
        name: 'feedback',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '用户反馈'
        }
      },
      {
        path: pre + '/growth',
        component: () => import('@views/my/growth'),
        name: 'growth',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '营销工具'
        }
      },
      {
        path: pre + '/growthShare',
        component: () => import('@views/my/growth/growthShare'),
        name: 'growthShare',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '领取礼品'
        }
      },
      {
        path: pre + '/bindUinId',
        component: () => import('@views/my/growth/bindUinId'),
        name: 'bindUinId',
        meta: {
          isLogin: true,
          isFooterShow: false,
          title : '绑定客机'
        }
      },
    ])('/my')
  }
]
